<template>
  <div class="myp" :class="getClass1">
    <v-btn
      v-if="!hasSelectedProject"
      fixed
      dark
      fab
      bottom
      right
      color="pink"
      class="mb-12"
      @click="addProject()"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <!-- mobile mode -->
    <div v-if="$vuetify.breakpoint.xsOnly">
      <template>
        <transition name="fadexxxx">
          <v-container v-if="!hasSelectedProject" class="myp2" fluid>
            <span v-for="project in filteredProjects" :key="project.projectID">
              <project-item-card :project="project"></project-item-card>
            </span>
          </v-container>
        </transition>
      </template>
      <template>
        <transition name="slide7">
          <v-container v-if="hasSelectedProject" class="myp2" fluid>
            <div class="deniz">
              <project-item-mobile :project="objProject"></project-item-mobile>
            </div>
          </v-container>
        </transition>
      </template>
    </div>

    <!-- desktop mode -->
    <div v-else>
      <!-- <h1>HELLO</h1> -->
      <v-container>
        <v-row>
          <v-col
            v-for="project in filteredProjects"
            :key="project.projectID"
            cols="12"
            md="6"
            lg="4"
            xl="3"
          >
            <project-item-card
              :project="project"
              @project-selected="showDialogProjectDesktop = true"
              style="height: 100%"
            ></project-item-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- general - show 'No Projects' and a PLUS button -->
    <v-container>
      <v-row v-if="filteredProjects.length == 0" dense class="mx-auto">
        <v-col>
          <v-alert dense outlined type="info" color="orange" elevation="12">
            <v-list-item-title>No projects to display</v-list-item-title>
            <v-list-item-subtitle>Click the + button below to add a new project!</v-list-item-subtitle>
          </v-alert>
        </v-col>
      </v-row>
    </v-container>

    <v-row justify="center">
      <v-dialog v-model="showDialogProjectDesktop" max-width="1260px">
        <DialogProjectDesktop @close-form="showDialogProjectDesktop = false" />
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="showingDialogNewProject" scrollable max-width="500px">
        <DialogProject :obj="objNewProject" />
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { db } from "../auth";
import { storeprops } from "@/store/helpers.js";
import { getCurrentDateISO8601 } from "@/shared";
import ProjectItemCard from "@/components/project/ProjectItemCard";
import ProjectItemMobile from "@/components/project/ProjectItemMobile";
//import ProjectItemDesktop from "@/components/project/ProjectItemDesktop";
import DialogProjectDesktop from "@/components/dialogs/DialogProjectDesktop";
import DialogProject from "@/components/dialogs/sections/DialogProject";

export default {
  components: {
    ProjectItemCard,
    ProjectItemMobile,
    DialogProjectDesktop,
    DialogProject,
  },
  props: {
    source: String,
  },
  data: () => ({
    objNewProject: null,
    showDialogProjectDesktop: false,
    showingDialogNewProject: false,
    objProject: null,
    getClass1: "", // "grey lighten-2"
    items: [
      { name: "Marcel", age: 52 },
      { name: "Deniz", age: 47 },
      { name: "Sam", age: 17 },
      { name: "Tom", age: 15 },
      { name: "Marcel2", age: 52 },
      { name: "Deniz2", age: 47 },
      { name: "Sam2", age: 17 },
      { name: "Tom2", age: 15 },
      { name: "Marcel3", age: 52 },
      { name: "Deniz3", age: 47 },
      { name: "Sam3", age: 17 },
      { name: "Tom3", age: 15 },
    ],
  }),
  computed: {
    ...storeprops,
    hasSelectedProject() {
      return this.$store.getters.hasSelectedProject;
    },
  },
  methods: {
    // getClass1() {
    //   debugger;
    //   return "blue-grey lighten-2 mt-6";
    // },
    toggle() {
      console.log("toggle");
    },
    addProject() {
      let project = {
        dateAccepted: null,
        dateEnquiry: getCurrentDateISO8601(),
        dateProposal: null,
        dateStarted: null,
        status: "",
        projectID: "",
        types: [],
        note: "",
        workItems: [],
        invoices: [],
        expenses: [],
        timesheets: [],
      };

      let toggle = (b) => (this.showingDialogNewProject = b);
      //obj.value = createDialogInfoObject();
      this.objNewProject = {};
      this.objNewProject.item = project;
      this.objNewProject.close = () => toggle(false);
      this.objNewProject.update = (project2) => {
        this.$store.dispatch("createProject", project2);
        toggle(false);
      };
      this.objNewProject.update.bind(this);
      toggle(true); // open the dialog
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.project-desktop {
  width: 382px;
  height: 335px;
  display: inline-block;
  margin-left: 10px;
}

.deniz {
  position: relative;
  // background: red;
  height: 100%;
  // overflow: scroll;
}

.slide6-enter-active {
  transition: all 0.6s ease-out;
}
.slide6-leave-active {
  transition: all 0.6s ease-in;
}
.slide6-enter {
  // transform: translateX(50%);
  opacity: 0;
}
.slide6-enter-to {
  // transform: translateX(0%);
  opacity: 1;
}
.slide6-leave {
  // transform: translateX(0%);
  // opacity: 1;
}
.slide6-leave-to {
  // transform: translateX(50%);
  opacity: 0;
}
</style>